import Typography from "Components/CommonComponents/Typography";
import "./index.css";
import cx from "classnames";
import { useState } from "react";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { SegmentMapping } from "utilFunctions/Constants/Constants";
import InfoIcon from "Assets/Icons/InfoIcon";
import FacultyStarIcon from "Assets/Icons/FacultyStarIcon";
import FeedbackViewModal from "./FeedbackViewModal";
import { Popover } from "antd";

interface IFacultyHeader {
  aggregatedDataLoading?: boolean;
  aggregatedData?: any;
  mode?: any;
  filterState?: any;
  onHandleSegmentSelection?: any;
}

function FacultyHealthHeader({
  aggregatedDataLoading,
  aggregatedData,
  mode,
  filterState,
}: // onHandleSegmentSelection,
IFacultyHeader) {
  const { screen }: any = useWindowSize();
  const [isLectureViewModal, setIsLectureViewModal] = useState<any>(false);

  const mapData = (aggregatedData: any, updatedDataForModal: any): [] => {
    const updatedFeedbackData = {
      behaviourInClassResponseAvg: aggregatedData[5]?.value,
      teachingPaceResponseAvg: aggregatedData[6]?.value,
      weightedNumberOfFeedback: aggregatedData[4]?.value,
      overallRatingResponseAvg: aggregatedData[3]?.value,
      doubtResolutionResponseAvg: aggregatedData[7]?.value,
    };
    if (mode === "regionFaculties") {
      updatedFeedbackData.weightedNumberOfFeedback = aggregatedData[4]?.value;
    } else {
      updatedFeedbackData.weightedNumberOfFeedback = aggregatedData[6]?.value;
    }
    updatedDataForModal.push(updatedFeedbackData);
    return updatedDataForModal;
  };

  const renderName = (item: any) => {
    switch (item) {
      case "totalFacultiesCount":
        return "Total Unique Faculties";
      case "markedLectures":
        return "Marked Lectures %";
      case "totalFeedbacksCount":
        return "Number of Feedbacks";
      case "unmarkedLectures":
        return "UNMARKED";
      case "overAllRating":
        return "Overall Rating";
      case "classBehaviour":
        return "Class Behaviour";
      case "teachingPace":
        return "Teaching Pace";
      case "doubtResolution":
        return "Doubt Resolution";
      case "alarmingRisk":
        return "ALARMING";
      case "followUpCount":
        return "Followed Up";
    }
  };
  //   switch (item) {
  //     case "totalBranch":
  //       return "Branch";
  //     case "totalActiveStudents":
  //       return "Students";
  //     case "active":
  //       return "Students";
  //     case "moderateRisk":
  //       return "Risk";
  //     case "highRisk":
  //       return "Risk";
  //     case "alarmingRisk":
  //       return "Risk";
  //     case "followUpCount":
  //       return "Students";
  //   }
  // };

  // const handleSegmentSelection = (selected: any) => {
  //   onHandleSegmentSelection(selected);
  // };
  const checkHeaderColor = (filters: any, label: any) => {
    if (
      filters?.segment != null &&
      SegmentMapping[filters?.segment?.label] == label
    ) {
      return true;
    } else {
      return false;
    }
  };

  const returnHeaderContentColor = (item: any) => {
    let cssStyle = "headerContent";
    if (item == "moderateRisk") {
      cssStyle = "headerSelectedContentModerate";
    } else if (item == "highRisk") {
      cssStyle = "headerSelectedContentHigh";
    } else if (item == "alarmingRisk") {
      cssStyle = "headerSelectedContentAlarming";
    } else {
      cssStyle = "headerStudentContent";
    }
    return cssStyle;
  };
  const renderCustomTooltip = (item: any, data: any) => {
    let cssStyle;
    const markedlecturesValue = data.filter(
      (el: any) => el.label == "markedLectures"
    )[0].value;
    const unmarkedLecturesValue = data.filter(
      (el: any) => el.label == "unmarkedLectures"
    )[0].value;
    const totalValue =
      Number(markedlecturesValue) + Number(unmarkedLecturesValue);
    if (item == "unmarkedLectures") {
      cssStyle = (
        <div className="d-flex flex-row w-100">
          <Typography variant="h6" color="black">
            {"Faculty Feedback"}
          </Typography>
        </div>
      );
    } else if (item == "overAllRating") {
      cssStyle = (
        <div className="d-flex flex-row w-100">
          <Typography variant="h6" color="black">
            {
              "Average overall rating based on student feedback on myAakash app within specified month range"
            }
          </Typography>
        </div>
      );
    } else if (item == "markedLectures") {
      cssStyle = (
        <div className="d-flex flex-column justify-content-start align-items-start">
          <Typography variant="h6" color="black">
            Marked lectures: {markedlecturesValue}
          </Typography>
          <Typography variant="h6" color="black">
            Total lectures: {totalValue}
          </Typography>
        </div>
      );
    } else if (item == "totalFacultiesCount") {
      cssStyle = (
        <div className="d-flex flex-row w-100">
          <Typography variant="h6" color="black">
            {"Total Faculties count"}
          </Typography>
        </div>
      );
    } else if (item == "totalFeedbacksCount") {
      cssStyle = (
        <div className="d-flex flex-row w-100">
          <Typography variant="h6" color="black">
            {"Total feedback received from student."}
          </Typography>
        </div>
      );
    } else {
      cssStyle = (
        <div className="d-flex flex-row w-100">
          <Typography variant="h6" color="black">
            {"Faculty Feedbacks"}
          </Typography>
        </div>
      );
    }
    return cssStyle;
  };
  const returnPercentage = (aggregatedData: any) => {
    const markedLectures = aggregatedData.filter(
      (el: any) => el.label == "markedLectures"
    )[0].value;
    const unmarkedLectures = aggregatedData.filter(
      (el: any) => el.label == "unmarkedLectures"
    )[0].value;
    let percentage = 0;
    if (markedLectures != 0 || unmarkedLectures != 0) {
      percentage =
        (Number(markedLectures) /
          (Number(markedLectures) + Number(unmarkedLectures))) *
        100;
      percentage = parseFloat(percentage.toFixed(0));
    }
    return percentage;
  };
  return (
    <>
      <FeedbackViewModal
        setYearMonthForFeedback={null}
        mode="myBatchLectureABC"
        selectedlecture={null}
        isLectureViewModal={isLectureViewModal}
        setIsLectureViewModal={setIsLectureViewModal}
        facultyFeedbackData={mapData(aggregatedData, [])}
      ></FeedbackViewModal>
      <div
        className={cx(
          ["facultyDetails"].includes(mode)
            ? "headerContentContainer pl-0"
            : "headerContentContainer",
          {
            deskTopViewBranchhealthHeader: ["xxl", "xl", "lg"].includes(screen),
            mobileViewBranchhealthHeader: !["xxl", "xl", "lg"].includes(screen),
          }
        )}
      >
        {!aggregatedDataLoading &&
          aggregatedData &&
          Array.isArray(aggregatedData) &&
          aggregatedData.map((item: { value: any; label: any }, index: any) => {
            return [
              "totalFacultiesCount",
              "markedLectures",
              "unmarkedLectures",
              "overAllRating",
              "totalFeedbacksCount",
            ].includes(item?.label) ? (
              <div
                className={
                  mode == "studentHome"
                    ? checkHeaderColor(filterState, item?.label)
                      ? returnHeaderContentColor(item?.label)
                      : "headerStudentContent"
                    : "headerContent"
                }
                key={index}
                onClick={() => {
                  if (item.label == "overAllRating") {
                    setIsLectureViewModal(true);
                    // handleSegmentSelection(item?.label);
                  }
                }}
              >
                <Typography variant="headingH3" color="black">
                  {item.label == "overAllRating" && <FacultyStarIcon />}{" "}
                  {item.value && item.value != null && item.value != ""
                    ? item.label == "markedLectures"
                      ? returnPercentage(aggregatedData) + "%"
                      : item.value
                    : 0}
                </Typography>
                <div
                  className="d-flex flex-row"
                  style={{ whiteSpace: "nowrap" }}
                >
                  <Typography
                    variant="h5"
                    color={
                      item.label == "totalFacultiesCount"
                        ? "secondary"
                        : item.label == "unmarkedLectures"
                        ? "yellow"
                        : item.label == "highRisk"
                        ? "red"
                        : item.label == "alarmingRisk"
                        ? "orange"
                        : "black"
                    }
                  >
                    {item.label === "unmarkedLectures" ? (
                      <>
                        {renderName(item.label)}
                        <span style={{ color: "black" }}>{" Lectures"}</span>
                      </>
                    ) : (
                      <>{renderName(item.label)}</>
                    )}
                    &nbsp;
                  </Typography>
                  {[
                    "overAllRating",
                    "totalFacultiesCount",
                    "markedLectures",
                    "totalFeedbacksCount",
                  ].includes(item?.label) ? (
                    <>
                      <Popover
                        placement={
                          item?.label == "markedLectures" ||
                          item?.label == "totalFacultiesCount"
                            ? "bottom"
                            : item?.label == "doubtResolution"
                            ? "left"
                            : "left"
                        }
                        content={() => (
                          <div>
                            {renderCustomTooltip(item?.label, aggregatedData)}
                            {/* {item?.label == "markedLectures" && (
                              <div className="text-muted">
                                Data includes in the ALC Classes
                              </div>
                            )} */}
                          </div>
                        )}
                        title={""}
                      >
                        {item.label !== "unmarkedLectures" && <InfoIcon />}
                      </Popover>
                    </>
                  ) : null}
                </div>
              </div>
            ) : null;
          })}
      </div>
    </>
  );
}
export default FacultyHealthHeader;
